module.exports = __webpack_public_path__ + "a03756fccad55bf97d351e77999aed68.svg";